import api from './index'

class AuthService {
	login(data) {
		return api.post('/login?prefix=' + data.prefix, data).then((res) => {
			localStorage.setItem('x-backend-auth', res.token)
			localStorage.setItem('x-prefix', data.prefix)

			return res
		})
	}
	getPermissions() {
		return api.get('/permissions')
	}
	getFeatures() {
		return api.get('/features')
	}
	logout() {
		return api.post('/logout').finally(() => {
			localStorage.removeItem('x-backend-auth')
		})
	}
}

export default new AuthService()
